<template>
<Preloader v-show="getShowPreloader"/>
  <div v-show="!getShowPreloader">
    <div
      v-show="getLayout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
    ></div>
    <Sidenav class="fixed-start" v-if="getShowSidenav" />
    <main
      class="
        main-content
        position-relative
        max-height-vh-100
        h-100
        border-radius-lg
      "
    >
      <!-- nav -->
      <navbar
        :class="[navClasses]"
        :textWhite="getIsAbsolute ? 'text-white opacity-8' : 'text-white'"
        :minNav="navbarMinimize"
        v-if="getShowNavbar"
      />
      <router-view />
      <Footer v-show="getShowFooter" />
    </main>
  </div>
</template>
<script>
import { Sidenav, Navbar, Footer, Preloader } from "@/components/exporter.js";
import { mapMutations, mapGetters } from "vuex";
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    Footer,
    Preloader
  },

  mounted() {
    if (localStorage.getItem("darkMode") === null) {
      localStorage.setItem("darkMode", true);
      activateDarkMode();
    } else {
      if (localStorage.getItem("darkMode") === "true") {
        this.setDarkModeMutation(true);
        activateDarkMode();
      } else {
        deactivateDarkMode();
      }
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "setDarkModeMutation"]),
  },
  computed: {
    ...mapGetters([
      "getIsNavFixed",
      "getIsLogined",
      "getIsAbsolute",
      "getUserData",
      "getShowFooter",
      "getDarkMode",
      "getShowNavbar",
      "getShowSidenav",
      "getLayout",
      "getShowPreloader"
    ]),
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky g-sidenav-hidden":
          this.getIsNavFixed && !this.getDarkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.getIsNavFixed && this.getDarkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.getIsAbsolute,
        "px-0 mx-4": !this.getIsAbsolute,
      };
    },
  },
};
</script>
